import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext'; // 경로를 프로젝트 구조에 맞게 조정
import Modal from '../ProtectedModal';

const ProtectedRoute = ({ element }) => {
  const { isLoggedIn } = useAuth();
  const [isLoading, setIsLoading] = useState(true); // 로딩 상태 추가
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // 로그인 상태가 로드되었을 때 로딩을 끝내기
    if (typeof isLoggedIn !== 'undefined') {
      setIsLoading(false);  // 로딩 끝
      if (!isLoggedIn) {
        setShowModal(true);
        const timer = setTimeout(() => {
          setShowModal(false);
          navigate('/Login');  // 로그인이 안 된 경우에만 로그인 페이지로 이동
        }, 500);
        return () => clearTimeout(timer);
      }
    }
  }, [isLoggedIn, navigate]);

  if (isLoading) {
    return <div>Loading...</div>;  // 로딩 상태일 때는 로딩 화면을 보여줌
  }

  if (!isLoggedIn) {
    return (
      <>
        <Modal isOpen={showModal}>
          <h2>로그인이 필요한 페이지입니다</h2>
        </Modal>
      </>
    );
  }

  return element;
};

export default ProtectedRoute;